import { useCallback, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import LayoutPartner from '../../components/BasicComponent/LayoutPartner'
import SafeImage from '../../components/BasicComponent/SafeImage'
import iconSuccess from '../../assets/images/payment_success.png'
import { PAYMENT_SUCCESS } from '../../constants/payment'
import { PATH } from '../../constants/router'
import { getUrlParamValue } from '../../helper/params'
import appUserService from '../../services/appUserService'
import './index.scss'

export default function AutomatedTrafficFineNotificationPaymentSuccess() {
  const history = useHistory()
  const isRedirectingRef = useRef(false)

  const handleRedirect = useCallback(
    (orderId) => {
      if (isRedirectingRef.current) {
        return
      }

      isRedirectingRef.current = true

      const rawRedirectData = getUrlParamValue('redirectData')

      if (orderId) {
        const successPath = PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS.replace(':id', orderId)
        const params = new URLSearchParams()

        if (rawRedirectData) {
          params.set('redirectData', rawRedirectData)
        }

        params.set('orderIdSuccess', orderId)

        const queryString = params.toString()

        history.replace(`${successPath}${queryString ? `?${queryString}` : ''}`)
        return
      }

      if (rawRedirectData) {
        history.replace(`${PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_REDIRECT_HANDLER}?redirectData=${rawRedirectData}`)
        return
      }

      history.replace(PATH.TRAFFIC_FINE_SERVICES)
    },
    [history]
  )

  useEffect(() => {
    const rawOrderIdSuccess = getUrlParamValue('orderIdSuccess')
    const orderId = Number(rawOrderIdSuccess)

    if (!rawOrderIdSuccess || Number.isNaN(orderId)) {
      const timeout = setTimeout(() => {
        handleRedirect()
      }, 3000)

      return () => clearTimeout(timeout)
    }

    const startTime = Date.now()
    let pollingInterval = null
    let maxTimeout = null

    const checkPaymentStatus = async () => {
      try {
        const result = await appUserService.getOrderDetail({ id: orderId })
        const { statusCode, data } = result || {}

        if (statusCode === 200 && data?.paymentStatus === PAYMENT_SUCCESS) {
          clearInterval(pollingInterval)
          clearTimeout(maxTimeout)

          const elapsedTime = Date.now() - startTime

         if (elapsedTime < 3000) {
            setTimeout(() => {
                handleRedirect(orderId)
            }, 3000 - elapsedTime)
            } else {
            handleRedirect(orderId)
            }
        }
      } catch (error) {
        console.error(error)
      }
    }

    checkPaymentStatus()

    pollingInterval = setInterval(checkPaymentStatus, 1000)

    maxTimeout = setTimeout(() => {
      clearInterval(pollingInterval)
      handleRedirect(orderId)
    }, 12000)

    return () => {
      clearInterval(pollingInterval)
      clearTimeout(maxTimeout)
    }
  }, [handleRedirect])

  return (
    <LayoutPartner>
      <div className="AutomatedTrafficFineNotificationPaymentSuccess">
        <div className="AutomatedTrafficFineNotificationPaymentSuccess_icon">
          <SafeImage src={iconSuccess} />
        </div>

        <div className="AutomatedTrafficFineNotificationPaymentSuccess_title">Thanh toán thành công</div>

        <div className="AutomatedTrafficFineNotificationPaymentSuccess_description">Bạn sẽ được chuyển hướng trong giây lát...</div>
      </div>
    </LayoutPartner>
  )
}